if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    constructor() {
      super();

      this.abortController = null;
    }

    connectedCallback() {
      this.source = this.dataset.source;
      this.productId = this.dataset.productId;
      this.cartProductsCount = this.dataset.cartProductIds.split(',').filter(Boolean).length;
      this.limit = parseInt(this.dataset.limit, 10) || 4;
      this.recommendationsUrl = this.dataset.recommendationsUrl;
      this.listElement = this.querySelector('[data-cart-recommendations-list]');

      if (this.source === 'custom') {
        this.initSlider();
      } else {
        this.loadRecommendations();
      }
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    async loadRecommendations() {
      if (!this.productId) return;

      this.abortController?.abort();
      this.abortController = new AbortController();

      const requestUrl = new URL(this.recommendationsUrl, window.location.origin);
      requestUrl.searchParams.set('section_id', 'cart-drawer-recommendations');
      requestUrl.searchParams.set('product_id', this.productId);
      requestUrl.searchParams.set('limit', String(Math.min(this.limit + this.cartProductsCount, 10)));
      requestUrl.searchParams.set('intent', 'related');

      try {
        const response = await fetch(requestUrl.href, { signal: this.abortController.signal });
        if (!response.ok) throw new Error(response.statusText);

        const sectionHtml = await response.text();
        const parsedSection = new DOMParser().parseFromString(sectionHtml, 'text/html');
        const incomingList = parsedSection.querySelector('[data-cart-recommendations-list]');

        if (!incomingList || incomingList.querySelectorAll('.swiper-slide').length === 0) return;

        this.listElement.replaceWith(incomingList);
        this.listElement = incomingList;
        this.hidden = false;
        this.initSlider();
      } catch (error) {
        if (error.name === 'AbortError') return;
        console.error('[cart-recommendations] fetch failed:', error);
      }
    }

    initSlider() {
      if (!this.listElement?.hasAttribute('data-slider-selector') || this.listElement.swiper) return;

      new SwiperConfigurator(this.listElement);
    }
  }

  customElements.define('cart-recommendations', CartRecommendations);
}
